<mat-sidenav-container hasBackdrop='false' class='filter-container' [ngClass]='{"map-height":displayMap}' autosize>
  <div class='container-lg h-100 pt-4' [ngClass]='{"overflow-hidden":displayMap}' *ngIf='!selectedItem'>
    <div class='row h-100'>

      <!--Filter Menu-->
      <div class='col-lg-3 d-none d-lg-flex justify-content-end' *ngIf='!this.displayMap'>
        <div class='list-container' id='filters-container' [ngClass]='{"filters-loading" : !itemsToDisplayFiltered}'>
          <h3 class='d-flex align-items-center justify-content-between'><strong>Filters</strong>
            <button class='btn btn-link' (click)='clearFilters()'><small>Clear all</small></button>
          </h3>
          <div>
            <div id='shedule-tests'>
              <h4 class='mb-2'>Dashboard schedule<i class='fas fa-search float-right mt-1'></i></h4>
              <input type='checkbox' id='shedule-checkbox' [value]='showScheduleTests' (click)="swichSchedule()"
                     class='archived-checkbox filters-input my-2' [checked]='showScheduleTests'/>
              <label class='mx-3 mb-0' for='shedule-checkbox'>Show</label>
            </div>
            <div id='archived-tests' *ngIf='userRole==="superuser"'>
              <h4 class='mb-2'>Archived Tests<i class='fas fa-search float-right mt-1'></i></h4>
              <input type='checkbox' id='archived-checkbox' [value]='showArchivedTests' (click)='handleFilterClick()'
                     class='archived-checkbox filters-input my-2' [checked]='showArchivedTests'/>
              <label class='mx-3 mb-0' for='bacteria-checkbox'>Show</label>
            </div>
            <hr>
            <div>
              <h4 class='mb-2'>Location / Water Source </h4>

              <mat-form-field appearance="legacy">
                <mat-label>Location</mat-label>
                <mat-select (selectionChange)="selectLocation($event)">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let location of filterLocation" [value]="location">
                    {{location}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="legacy">
                <mat-label>Water Source</mat-label>
                <mat-select [(value)]="waterSourceSelected" (selectionChange)="selectWaterSource($event)">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let source of filterWaterSource" [value]="source">
                    {{source}}
                  </mat-option>
                </mat-select>
              </mat-form-field>

            </div>
            <hr>
            <div id='types'>
              <h4 class='mb-2'>Types<i class='fas fa-search float-right mt-1'></i></h4>
              <div class='d-flex align-items-center' *ngIf='showTestType("bacteria")'>
                <input type='checkbox' id='bacteria-checkbox' value='bacteria' (click)='handleFilterClick()'
                       class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("bacteria")'/>
                <label class='mx-3 mb-0' for='bacteria-checkbox'>Bacteria</label>
              </div>
              <div class='d-flex align-items-center' *ngIf='showTestType("lead")'>
                <input type='checkbox' value='lead' (click)='handleFilterClick()' id='lead-checkbox'
                       class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("lead")'/>
                <label class='mx-3 mb-0' for='lead-checkbox'>Lead</label>
              </div>
              <div class='d-flex align-items-center' *ngIf='showTestType("legionella")'>
                <input type='checkbox' value='legionella' (click)='handleFilterClick()' id='legionella-checkbox'
                       class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("legionella")'/>
                <label class='mx-3 mb-0' for='legionella-checkbox'>Legionella</label>
              </div>
              <div class='d-flex align-items-center' *ngIf='showTestType("h2o2")'>
                <input type='checkbox' value='h2o2' (click)='handleFilterClick()' id='h2o2-checkbox'
                       class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("h2o2")'/>
                <label class='mx-3 mb-0' for='h2o2-checkbox'>H2O2</label>
              </div>
              <div class='d-flex align-items-center' *ngIf='showTestType("chlorine")'>
                <input type='checkbox' value='chlorine' (click)='handleFilterClick()' id='chlorine-checkbox'
                       class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("chlorine")'/>
                <label class='mx-3 mb-0'
                       for='chlorine-checkbox'>Free Chlorine</label>
              </div>
              <div class='d-flex align-items-center' *ngIf='showTestType("ecoli")'>
                <input type='checkbox' value='ecoli' (click)='handleFilterClick()' id='ecoli-checkbox'
                       class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("ecoli")'/>
                <label class='mx-3 mb-0'
                       for='ecoli-checkbox'>E. Coli</label>
              </div>
              <div class='d-flex align-items-center' *ngIf='showTestType("c19")'>
                <input type='checkbox' value='c19' (click)='handleFilterClick()' id='c19-checkbox'
                       class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("c19")'/>
                <label class='mx-3 mb-0' for='c19-checkbox'>C19</label>
              </div>
            </div>
            <hr>
            <div id='date'>
              <h4 class='mb-2'>Date<i class='fas fa-search float-right mt-1'></i></h4>

              <div class='d-flex align-items-center'>

                <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 604800'
                       class='filters-input my-2' [checked]='dateFilterChosen === timestamp - 604800'
                       id='7-days' name='date-radio'>
                <label class='mx-3 mb-0' for='7-days'>Last 7 days</label>
              </div>
              <div class='d-flex align-items-center'>

                <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 2592000'
                       class='filters-input my-2' [checked]='dateFilterChosen === timestamp - 2592000'
                       id='30-days' name='date-radio'>
                <label class='mx-3 mb-0' for='30-days'>Last 30 days</label>
              </div>
              <div class='d-flex align-items-center'>

                <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 15780000'
                       class='filters-input my-2' id='6-months' [checked]='dateFilterChosen === timestamp - 15780000'
                       name='date-radio'>
                <label class='mx-3 mb-0' for='6-months'>Last 6 months</label>
              </div>
              <div class='d-flex align-items-center'>

                <input type='radio' (click)='handleFilterClick()'
                       [checked]='dateFilterChosen === timestamp - 31536000' [value]='timestamp - 31536000'
                       class='filters-input my-2' id='1-year' name='date-radio'>
                <label class='mx-3 mb-0' for='1-year'>Last 1 year</label>
              </div>
              <div class='d-flex align-items-center'>

                <input type='radio' (click)='handleFilterClick()' [value]='0' [checked]='dateFilterChosen === 0'
                       class='filters-input my-2'
                       id='all-time' name='date-radio'>
                <label class='mx-3 mb-0' for='all-time'>All time</label>
              </div>
              <div class='my-2'>

                <mat-form-field class='w-100 my-0 border-top-0'>
                  <label for='start'>Start date:</label>

                  <input matInput type='date' (change)='handleStartDateChange($event)' id='start'
                         class='filters-input mb-2' name='date-start'>
                </mat-form-field>
                <mat-form-field class='w-100 my-0 border-top-0'>

                  <label for='end'>End date:</label>

                  <input matInput type='date' id='end' (change)='handleEndDateChange($event)'
                         class='filters-input mb-2'
                         name='date-end'>
                </mat-form-field>

              </div>
            </div>
            <hr *ngIf='userRole === "superuser"'>
            <div *ngIf='userRole === "superuser"'>
              <h4 class='mb-2'>Organizations<i class='fas fa-search float-right mt-1'></i></h4>
              <mat-form-field class='w-100'>
                <mat-label>Search Orgs</mat-label>
                <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

                <input matInput type='text' (keyup)='updateOrgFilterSearchTerm($event)'>
              </mat-form-field>
              <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%',
          'margin-left': '1em'
        }" *ngIf='!orgsLoaded'></ngx-skeleton-loader>
              <div class='org-scroll'>
                <div *ngFor='let org of orgListDisplayed | keyvalue' class='d-flex align-items-center overflow-hidden'
                     [hidden]='!orgsLoaded'>
                  <div *ngIf='org["value"]["id"]' class='d-inline-flex align-items-center'>

                    <input type='checkbox' name='org-checkbox-1' (click)='handleFilterClick()'
                           [value]='org["value"]["id"]' [id]='org["value"]["id"]'
                           [checked]='orgFiltersChosen.includes(org["value"]["id"])'
                           class='filters-input my-2 org-checkbox'/>

                    <label class='mx-3 mb-0'
                           [for]='org["value"]["id"]'>{{org["value"]["name"]}}</label>
                  </div>
                </div>
              </div>

            </div>
            <hr>
            <div *ngIf='userRole === "superuser" || userRole === "admin"'>
              <h4 class='mb-2'>Users<i class='fas fa-search float-right mt-1'></i></h4>
              <mat-form-field class='w-100'>
                <mat-label>Search users</mat-label>
                <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

                <input matInput type='text' (keyup)='updateUserFilterSearchTerm($event)'>
              </mat-form-field>
              <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%',
          'margin-left': '1em'
        }" *ngIf='!usersLoaded'></ngx-skeleton-loader>
              <div class='user-scroll'>
                <div *ngFor='let user of userListDisplayed | keyvalue' class='d-flex align-items-center overflow-hidden'
                     [hidden]='!usersLoaded'>
                  <div *ngIf='user["value"]["data"]' class='d-inline-flex align-items-center'>

                    <input type='checkbox' name='user-checkbox-1' (click)='handleFilterClick()'
                           [value]='user["value"]["data"]["uid"]' [id]='user["value"]["data"]["uid"]'
                           [checked]='userFiltersChosen.includes(user["value"]["data"]["uid"])'
                           class='filters-input my-2 user-checkbox'/>

                    <label class='mx-3 mb-0'
                           [for]='user["value"]["data"]["uid"]'>{{user["value"]["data"]["displayName"] || user["value"]["data"]["email"]}}</label>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div [ngClass]="{
                 'col-12 col-lg-9' : !displayMap,
                 'col-4 h-100' : displayMap
           }"
           id='test-list'>
        <div class='row mb-3 mx-0 d-flex justify-content-start' *ngIf='!displayMap && showScheduleTests' id='main-content-container'>
          <app-chart-gyr [hidden]="!testDataTrue || !testListLoaded" class='col-12 pr-0'></app-chart-gyr>
          <div [hidden]="testDataTrue"><h2>No data to display PieChart!</h2></div>

          <app-chart-cfm [hidden]="!testChartDataTrue || !testListLoaded" class='col-12 pr-0'></app-chart-cfm>
          <div [hidden]="testChartDataTrue"><h2>No data to display graph!</h2></div>
        </div>
        <div>
          <div class='mb-2'>
            <mat-form-field class='w-100'>
              <mat-label>Search within displayed results by test type, location or notes</mat-label>
              <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

              <input matInput type='text' (keyup)='updateSearchTerm($event)'>
            </mat-form-field>

          </div>
          <ngx-skeleton-loader count='1' [theme]="{
          'width': '50%'
        }" [hidden]='testListLoaded'></ngx-skeleton-loader>

          <h2 class='my-3 d-flex justify-content-between align-items-center' *ngIf='itemsToDisplay'
              [hidden]='!testListLoaded'>
            <p>{{displayMap ? "" : "Showcasing"}} {{itemsToDisplayFiltered?.length}} test {{resultsString}}</p>


            <div *ngIf='itemsToDisplay && displayMap' class='d-flex justify-content-between'>
              <button class='btn d-flex align-items-center justify-content-between' (click)='openDrawer()'
                      id='filter-button-map'>
                <img src='../../../assets/FilterVector.png' class='mr-2' height='10' width='16'/>
                Filter
              </button>
              <button class='btn btn-link mr-1' (click)='clearFilters()'><small>Clear all</small></button>

            </div>


            <div *ngIf='itemsToDisplay && !displayMap' class='d-flex justify-content-between'>
              <button *ngIf="this.userRole === 'superuser' || this.userRole === 'admin'" class='btn btn-primary' (click)='downloadCSV()'>
                Download {{itemsToDisplayFiltered?.length}} results CSV
              </button>
              <button class='btn btn-primary' (click)='downloadPDF()'>
                Download {{itemsToDisplayFiltered?.length}} results PDF
              </button>
              <button [hidden]="!this.isAdmin" class='btn btn-primary btn-outline' (click)='downloadRawData()'>
                Download {{itemsToDisplayFiltered?.length}} Raw Data
              </button>
            </div>
          </h2>
        </div>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 tableTest">

          <!-- Date -->
          <ng-container matColumnDef="date">
            <th mat-header-cell class="line-border" *matHeaderCellDef> Date </th>
            <td mat-cell class="line-border" *matCellDef="let doc">
              <div *ngIf="!testListLoaded; else showData">
                <ngx-skeleton-loader [theme]="{
                  'width': '100%'
                }"></ngx-skeleton-loader>
              </div>
              <ng-template #showData>
                {{doc?.date._seconds * 1000 | date :'short'}}
              </ng-template>
            </td>
          </ng-container>

          <!-- Test -->
          <ng-container matColumnDef="test">
            <th mat-header-cell class="line-border" *matHeaderCellDef> Test </th>
            <td mat-cell class="text-capitalize line-border" *matCellDef="let doc">
              <div *ngIf="!testListLoaded; else showData">
                <ngx-skeleton-loader [theme]="{
                  'width': '100%'
                }"></ngx-skeleton-loader>
              </div>
              <ng-template #showData>
                {{doc?.calculationResult.testType}}
              </ng-template>
            </td>
          </ng-container>

          <!-- Note -->
          <ng-container matColumnDef="note">
            <th mat-header-cell class="line-border" *matHeaderCellDef> Note </th>
            <td mat-cell class="line-border" *matCellDef="let doc">
              <div *ngIf="!testListLoaded; else showData">
                <ngx-skeleton-loader [theme]="{
                  'width': '100%'
                }"></ngx-skeleton-loader>
              </div>
              <ng-template #showData>
                <div *ngIf="doc">
                  <app-note-field [testData]="doc"></app-note-field>
                </div>
              </ng-template>
            </td>
          </ng-container>

          <!-- Water Sourece -->
          <ng-container matColumnDef="waterSourece">
            <th mat-header-cell class="line-border" *matHeaderCellDef> Water Sourece </th>
            <td mat-cell class="line-border" *matCellDef="let doc">
              <div *ngIf="!testListLoaded; else showData">
                <ngx-skeleton-loader [theme]="{
                  'width': '100%'
                }"></ngx-skeleton-loader>
              </div>
              <ng-template #showData>
                {{doc?.location?.waterSource || "No Water Source Chosen"}}
              </ng-template>
            </td>
          </ng-container>

          <!-- Green/Yellow/Red -->
          <ng-container matColumnDef="GYR">
            <th mat-header-cell class="line-border" *matHeaderCellDef> GYR </th>
            <td mat-cell class="line-border" *matCellDef="let doc">
              <div *ngIf="!testListLoaded; else showData">
                <ngx-skeleton-loader [theme]="{
                  'width': '100%'
                }"></ngx-skeleton-loader>
              </div>
              <ng-template #showData>
                <div *ngIf="doc">
                  <app-color-gradation [testData]='doc'></app-color-gradation>
                </div>

              </ng-template>
            </td>
          </ng-container>

          <!-- Details -->
          <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef> Details </th>
            <td mat-cell *matCellDef="let doc">
              <div *ngIf="!testListLoaded; else showData">
                <ngx-skeleton-loader [theme]="{
                  'width': '100%'
                }"></ngx-skeleton-loader>
              </div>
              <ng-template #showData>
<!--                <button class='btn btn-link col-12 px-0 ml-lg-1 view-details-button'-->
<!--                        [ngClass]='{"col-lg-2":!displayMap}'-->
<!--                        (click)='navigateToTest(doc?.calculationResult.testId)'>{{ 'details' || ''}}-->
<!--                </button>-->
                <a target="_blank" href="/test/{{doc?.calculationResult.testId}}">details</a>
              </ng-template>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator [length]="length"
                       [pageSize]=pageLimit
                       [pageSizeOptions]="pageSizeOptions"
                       (page)="onPageChanged($event)">
        </mat-paginator>

        <mat-sidenav #drawer [ngClass]='{"filters-sidenav": !displayMap, "map-filters-sidenav": displayMap}' mode='side'
                     *ngIf='itemsToDisplay'>


          <!--Filter Menu-->
          <div class='list-container' id='filters-container-drawer'>
            <div *ngIf='!displayMap'>
              <h3 class='d-flex align-items-center justify-content-between'><strong>Filters</strong>
                <button class='btn btn-link' (click)='clearFilters()'><small>Clear all</small></button>
              </h3>
              <mat-tab-group>
                <mat-tab label='Type'>
                  <div id='types-drawer'>
                    <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%'
        }" [hidden]='testListLoaded'></ngx-skeleton-loader>
                    <div class='d-flex align-items-center' *ngIf='showTestType("bacteria")'>
                      <input type='checkbox' id='bacteria-checkbox-drawer' value='bacteria'
                             [checked]='mobileDrawerOpened && typeFiltersChosen.includes("bacteria")'
                             (click)='handleFilterClick()'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0'
                             for='bacteria-checkbox-drawer'>Bacteria</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("lead")'>
                      <input type='checkbox' value='lead' (click)='handleFilterClick()' id='lead-checkbox-drawer'
                             [checked]='mobileDrawerOpened && typeFiltersChosen.includes("lead")'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0' for='lead-checkbox-drawer'>Lead</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("legionella")'>
                      <input type='checkbox' value='legionella' (click)='handleFilterClick()'
                             id='legionella-checkbox-drawer'
                             class='type-checkbox filters-input my-2'
                             [checked]='mobileDrawerOpened && typeFiltersChosen.includes("legionella")'/>
                      <label class='mx-3 mb-0' for='legionella-checkbox-drawer'>Legionella</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("h2o2")'>
                      <input type='checkbox' value='h2o2' (click)='handleFilterClick()' id='h2o2-checkbox-drawer'
                             [checked]='mobileDrawerOpened && typeFiltersChosen.includes("h2o2")'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0' for='h2o2-checkbox-drawer'>H2O2</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("chlorine")'>
                      <input type='checkbox' value='chlorine' (click)='handleFilterClick()'
                             [checked]='mobileDrawerOpened && typeFiltersChosen.includes("chlorine")'
                             id='chlorine-checkbox-drawer'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0'
                             for='chlorine-checkbox-drawer'>Free Chlorine</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("ecoli")'>
                      <input type='checkbox' value='ecoli' (click)='handleFilterClick()' id='ecoli-checkbox-drawer'
                             class='type-checkbox filters-input my-2'
                             [checked]='mobileDrawerOpened && typeFiltersChosen.includes("ecoli")'/>
                      <label class='mx-3 mb-0'
                             for='ecoli-checkbox-drawer'>E. Coli</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("c19")'>
                      <input type='checkbox' value='c19' (click)='handleFilterClick()' id='c19-checkbox-drawer'
                             [checked]='mobileDrawerOpened && typeFiltersChosen.includes("c19")'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0' for='c19-checkbox-drawer'>C19</label>
                    </div>
                  </div>
                </mat-tab>
                <mat-tab label='Date'>
                  <div id='date-drawer'>
                    <ngx-skeleton-loader count='6' [theme]="{
          'width': '75%'
        }" [hidden]='testListLoaded'></ngx-skeleton-loader>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 604800'
                             [checked]='dateFilterChosen === timestamp - 604800'
                             class='filters-input my-2'
                             id='7-days-drawer' name='date-radio'>
                      <label class='mx-3 mb-0' for='7-days-drawer'>Last 7 days</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 2592000'
                             [checked]='dateFilterChosen === timestamp - 2592000'
                             class='filters-input my-2'
                             id='30-days-drawer' name='date-radio'>
                      <label class='mx-3 mb-0'
                             for='30-days-drawer'>Last 30 days</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 15780000'
                             [checked]='dateFilterChosen === timestamp - 15780000'
                             class='filters-input my-2' id='6-months-drawer' name='date-radio'>
                      <label class='mx-3 mb-0'
                             for='6-months-drawer'>Last 6 months</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 31536000'
                             [checked]='dateFilterChosen === timestamp - 31536000'
                             class='filters-input my-2' id='1-year-drawer' name='date-radio'>
                      <label class='mx-3 mb-0' for='1-year-drawer'>Last 1 year</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='0' [checked]='dateFilterChosen === 0'
                             class='filters-input my-2'
                             id='all-time-drawer' name='date-radio'>
                      <label class='mx-3 mb-0' for='all-time-drawer'>All time</label>
                    </div>
                    <div class='my-2'>

                      <mat-form-field class='w-100 my-0 border-top-0'>
                        <label for='start-drawer'>Start date:</label>

                        <input matInput type='date' (change)='handleStartDateChange($event)' id='start-drawer'
                               class='filters-input mb-2' name='date-start'>
                      </mat-form-field>
                      <mat-form-field class='w-100 my-0 border-top-0'>

                        <label for='end-drawer'>End date:</label>

                        <input matInput type='date' id='end-drawer' (change)='handleEndDateChange($event)'
                               class='filters-input mb-2'
                               name='date-end'>
                      </mat-form-field>

                    </div>
                  </div>
                </mat-tab>
                <mat-tab label='Org' *ngIf='userRole === "superuser"' id='orgs-drawer'>


                  <h4 class='mb-2'>Organizations<i class='fas fa-search float-right mt-1'></i></h4>
                  <mat-form-field class='w-100'>
                    <mat-label>Search Orgs</mat-label>
                    <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

                    <input matInput type='text' (keyup)='updateOrgFilterSearchTerm($event)'>
                  </mat-form-field>
                  <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%',
          'margin-left': '1em'
        }" *ngIf='!orgsLoaded'></ngx-skeleton-loader>
                  <div class='org-scroll'>
                    <div *ngFor='let org of orgListDisplayed | keyvalue'
                         class='d-flex align-items-center overflow-hidden'
                         [hidden]='!orgsLoaded'>
                      <div *ngIf='org["value"]["id"]' class='d-inline-flex align-items-center'>

                        <input type='checkbox' name='org-checkbox-1' (click)='handleFilterClick()'
                               [value]='org["value"]["id"]' [id]='org["value"]["id"]+"-drawer"'
                               class='filters-input my-2 org-checkbox'
                               [checked]='orgFiltersChosen.includes(org["value"]["id"])'/>

                        <label class='mx-3 mb-0'
                               [for]='org["value"]["id"]+"-drawer"'>{{org["value"]["name"]}}</label>
                      </div>
                    </div>
                  </div>

                </mat-tab>
                <mat-tab label='User' *ngIf='userRole === "superuser" || userRole === "admin"'>
                  <div id='users-drawer'>
                    <h4 class='mb-2'>Users<i class='fas fa-search float-right mt-1'></i></h4>
                    <mat-form-field class='w-100'>
                      <mat-label>Search users</mat-label>
                      <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

                      <input matInput type='text' (keyup)='updateUserFilterSearchTerm($event)'>
                    </mat-form-field>
                    <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%'
        }" [hidden]='testListLoaded'></ngx-skeleton-loader>
                    <div class='user-scroll'>
                      <div *ngFor='let user of userListDisplayed | keyvalue' class='d-flex align-items-center'>
                        <div *ngIf='user["value"]["data"]'>

                          <input type='checkbox' name='user-checkbox-1' (click)='handleFilterClick()'
                                 [value]='user["value"]["data"]["uid"]'
                                 [checked]='userFiltersChosen.includes(user["value"]["data"]["uid"])'
                                 [id]='user["value"]["data"]["uid"]+"-drawer"'
                                 class='filters-input my-2 user-checkbox'/>

                          <label class='mx-3 mb-0'
                                 [for]='user["value"]["data"]["uid"]+"-drawer"'>{{user["value"]["data"]["displayName"]}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
              <div class='margin-top'>
                <hr>
                <div class='d-flex justify-content-center '>

                  <button class='btn btn-link text-dark' (click)='closeDrawer()'
                          id='close-button'>Close
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf='displayMap'>
              <button type='button' class='close' aria-label='Close' (click)='closeDrawer()'>
                <span aria-hidden='true'>&times;</span>
              </button>
              <div class='mt-2'>

                <h3 class='d-flex align-items-center justify-content-between w-100'><strong>Filters</strong>
                  <button class='btn btn-link' (click)='clearFilters()'><small>Clear all</small></button>
                </h3>
                <div>
                  <div id='types-drawer-map'>
                    <h4 class='mb-2'>Types<i class='fas fa-search float-right mt-1'></i></h4>
                    <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%'
        }" [hidden]='testListLoaded'></ngx-skeleton-loader>
                    <div class='d-flex align-items-center' *ngIf='showTestType("bacteria")'>
                      <input type='checkbox' id='bacteria-checkbox-drawer-map' value='bacteria'
                             [checked]='typeFiltersChosen.includes("bacteria")'
                             (click)='handleFilterClick()'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0'
                             for='bacteria-checkbox-drawer-map'>Bacteria</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("lead")'>
                      <input type='checkbox' value='lead' (click)='handleFilterClick()' id='lead-checkbox-drawer-map'
                             [checked]='typeFiltersChosen.includes("lead")'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0'
                             for='lead-checkbox-drawer-map'>Lead</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("legionella")'>
                      <input type='checkbox' value='legionella' (click)='handleFilterClick()'
                             id='legionella-checkbox-drawer-map'
                             class='type-checkbox filters-input my-2'
                             [checked]='typeFiltersChosen.includes("legionella")'/>
                      <label class='mx-3 mb-0' for='legionella-checkbox-drawer-map'>Legionella</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("h2o2")'>
                      <input type='checkbox' value='h2o2' (click)='handleFilterClick()' id='h2o2-checkbox-drawer-map'
                             [checked]='typeFiltersChosen.includes("h2o2")'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0'
                             for='h2o2-checkbox-drawer-map'>H2O2</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("chlorine")'>
                      <input type='checkbox' value='chlorine' (click)='handleFilterClick()'
                             [checked]='typeFiltersChosen.includes("chlorine")'
                             id='chlorine-checkbox-drawer-map'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0'
                             for='chlorine-checkbox-drawer-map'>Free Chlorine</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("ecoli")'>
                      <input type='checkbox' value='ecoli' (click)='handleFilterClick()' id='ecoli-checkbox-drawer-map'
                             class='type-checkbox filters-input my-2' [checked]='typeFiltersChosen.includes("ecoli")'/>
                      <label class='mx-3 mb-0'
                             for='ecoli-checkbox-drawer-map'>E. Coli</label>
                    </div>
                    <div class='d-flex align-items-center' *ngIf='showTestType("c19")'>
                      <input type='checkbox' value='c19' (click)='handleFilterClick()' id='c19-checkbox-drawer-map'
                             [checked]='typeFiltersChosen.includes("c19")'
                             class='type-checkbox filters-input my-2'/>
                      <label class='mx-3 mb-0' for='c19-checkbox-drawer-map'>C19</label>
                    </div>
                  </div>
                  <hr>
                  <div id='date-drawer-map'>
                    <h4 class='mb-2'>Date<i class='fas fa-search float-right mt-1'></i></h4>
                    <ngx-skeleton-loader count='6' [theme]="{
          'width': '75%'
        }" [hidden]='testListLoaded'></ngx-skeleton-loader>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 604800'
                             [checked]='dateFilterChosen === timestamp - 604800'
                             class='filters-input my-2'
                             id='7-days-drawer-map' name='date-radio'>
                      <label class='mx-3 mb-0'
                             for='7-days-drawer-map'>Last 7 days</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 2592000'
                             [checked]='dateFilterChosen === timestamp - 2592000'
                             class='filters-input my-2'
                             id='30-days-drawer-map' name='date-radio'>
                      <label class='mx-3 mb-0'
                             for='30-days-drawer-map'>Last 30 days</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 15780000'
                             [checked]='dateFilterChosen === timestamp - 15780000'
                             class='filters-input my-2' id='6-months-drawer-map' name='date-radio'>
                      <label class='mx-3 mb-0'
                             for='6-months-drawer-map'>Last 6 months</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='timestamp - 31536000'
                             [checked]='dateFilterChosen === timestamp - 31536000'
                             class='filters-input my-2' id='1-year-drawer-map' name='date-radio'>
                      <label class='mx-3 mb-0'
                             for='1-year-drawer-map'>Last 1 year</label>
                    </div>
                    <div class='d-flex align-items-center'>

                      <input type='radio' (click)='handleFilterClick()' [value]='0' [checked]='dateFilterChosen === 0'
                             class='filters-input my-2'
                             id='all-time-drawer-map' name='date-radio'>
                      <label class='mx-3 mb-0' for='all-time-drawer-map'>All time</label>
                    </div>
                    <div class='my-2'>

                      <mat-form-field class='w-100 my-0 border-top-0'>
                        <label for='start-drawer-map'>Start date:</label>

                        <input matInput type='date' (change)='handleStartDateChange($event)' id='start-drawer-map'
                               class='filters-input mb-2' name='date-start'>
                      </mat-form-field>
                      <mat-form-field class='w-100 my-0 border-top-0'>

                        <label for='end-drawer-map'>End date:</label>

                        <input matInput type='date' id='end-drawer-map' (change)='handleEndDateChange($event)'
                               class='filters-input mb-2'
                               name='date-end'>
                      </mat-form-field>

                    </div>
                  </div>
                  <hr>
                  <div *ngIf='userRole === "superuser"' id='orgs-drawer-map'>


                    <h4 class='mb-2'>Organizations<i class='fas fa-search float-right mt-1'></i></h4>
                    <mat-form-field class='w-100'>
                      <mat-label>Search Orgs</mat-label>
                      <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

                      <input matInput type='text' (keyup)='updateOrgFilterSearchTerm($event)'>
                    </mat-form-field>
                    <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%',
          'margin-left': '1em'
        }" *ngIf='!orgsLoaded'></ngx-skeleton-loader>
                    <div class='org-scroll'>
                      <div *ngFor='let org of orgListDisplayed | keyvalue'
                           class='d-flex align-items-center overflow-hidden'
                           [hidden]='!orgsLoaded'>
                        <div *ngIf='org["value"]["id"]' class='d-inline-flex align-items-center'>

                          <input type='checkbox' name='org-checkbox-1' (click)='handleFilterClick()'
                                 [value]='org["value"]["id"]' [id]='org["value"]["id"]+"-drawer-map"'
                                 class='filters-input my-2 org-checkbox'
                                 [checked]='orgFiltersChosen.includes(org["value"]["id"])'/>

                          <label class='mx-3 mb-0'
                                 [for]='org["value"]["id"]+"-drawer-map"'>{{org["value"]["name"]}}</label>
                        </div>
                      </div>
                    </div>

                  </div>
                  <hr>

                  <div>
                    <h4 class='mb-2'>Users<i class='fas fa-search float-right mt-1'></i></h4>
                    <mat-form-field class='w-100'>
                      <mat-label>Search users</mat-label>
                      <span matPrefix>
              <i class='fas fa-search my-0 mx-2'></i>
            </span>

                      <input matInput type='text' (keyup)='updateUserFilterSearchTerm($event)'>
                    </mat-form-field>
                    <ngx-skeleton-loader count='3' [theme]="{
          'width': '75%'
        }" [hidden]='testListLoaded'></ngx-skeleton-loader>
                    <div class='user-scroll'>

                      <div *ngFor='let user of userListDisplayed | keyvalue' class='d-flex align-items-center'>
                        <input type='checkbox' name='user-checkbox-1' (click)='handleFilterClick()'
                               [value]='user["value"]["data"]["uid"]'
                               [checked]='userFiltersChosen.includes(user["value"]["data"]["uid"])'
                               [id]='user["value"]["data"]["uid"] + "-drawer-map"'
                               class='filters-input my-2 user-checkbox'/>

                        <label class='mx-3 mb-0'
                               [for]='user["value"]["data"]["uid"] + "-drawer-map"'>{{user["value"]["data"]["displayName"]}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-sidenav>
        <div class='mat-drawer-backdrop mat-drawer-shown' [hidden]='!drawerOpened' *ngIf='displayMap'></div>

        <div class='d-flex d-lg-none justify-content-center' *ngIf='itemsToDisplay && !displayMap'>
          <button class='btn btn-primary filter-button' (click)='drawerToggle()'
                  id='filter-button'>Filter
          </button>
        </div>

      </div>
      <div *ngIf='displayMap && itemsToDisplay' class='col-8 sticky-top z-index-0'>
        <google-map
          height='100%'
          width='100%'
          [zoom]='zoom'
          [center]='center'>
          <map-marker
            #markerElem='mapMarker'
            *ngFor='let marker of markers'
            [id]='marker.id'
            [position]='marker.position'
            [label]='null'

            [title]='marker.title'
            [options]='marker.options'
            (mapClick)='openInfo(markerElem, marker.info)'>

          </map-marker>
          <map-info-window>
            <div [innerHTML]='infoContent | safeHtml'></div>
          </map-info-window>
        </google-map>
      </div>
    </div>
  </div>
</mat-sidenav-container>
